import { ShadowGenerator } from '@babylonjs/core/Lights/Shadows/shadowGenerator';
import { Mesh } from '@babylonjs/core/Meshes/mesh';
import { RenderTargetTexture } from '@babylonjs/core/Materials/Textures/renderTargetTexture';

import { SystemCamera } from './systemCamera';

export class SystemLayer extends SystemCamera {
    /**
     * List of all the shadowGenerator so that we can choose which mesh will cast shadow
     */
    private shadowGenerators: ShadowGenerator[] = [];

    /**
    * List of all the Meshes to cast a shadow
    */
    private shadowMeshRenderlist: Mesh[] = [];

    /**
     * Build all the essentials assets for the 3D Scene
     */
    constructor(canvas: HTMLCanvasElement) {
        super(canvas);

        // The system uses no shadows by default so we must activate it for studio
        this.scene.shadowsEnabled = true;
    }

    public addShadowCaster(mesh: Mesh): void {
        this.shadowGenerators.forEach((shadowGenerator) => {
            shadowGenerator.addShadowCaster(mesh);
        });
        const index = this.shadowMeshRenderlist.indexOf(mesh);
        if (index === -1) this.shadowMeshRenderlist.push(mesh);
        this.resetShadows();
    }

    public removeShadowCaster(mesh: Mesh): void {
        this.shadowGenerators.forEach((shadowGenerator) => {
            shadowGenerator.removeShadowCaster(mesh);
        });
        const index = this.shadowMeshRenderlist.indexOf(mesh);
        if (index !== -1) this.shadowMeshRenderlist.splice(index, 1);
        this.resetShadows();
    }

    /**
     * @ignore
     */
    public addShadowGenerator(shadowGenerator: ShadowGenerator): void {
        this.shadowMeshRenderlist.forEach((shadowMeshRender) => {
            shadowGenerator.addShadowCaster(shadowMeshRender);
        });
        this.shadowGenerators.push(shadowGenerator);
        this.checkActiveMeshes();
    }

    /**
     * @ignore
     */
    public removeShadowGenerator(shadowGenerator: ShadowGenerator): void {
        const shadowMap = shadowGenerator.getShadowMap();
        if (shadowMap) shadowMap.renderList = [];
        shadowGenerator.dispose();
        const index = this.shadowGenerators.indexOf(shadowGenerator);
        if (index !== -1) this.shadowGenerators.splice(index, 1);
        this.checkActiveMeshes();
    }

    public resetShadows(): void {
        this.shadowGenerators.forEach((shadowGenerator) => {
            const map = shadowGenerator.getShadowMap();
            map.refreshRate = RenderTargetTexture.REFRESHRATE_RENDER_ONEVERYFRAME;
        });
        if (this.optimizedShadows) {
            this.executeOnceBeforeRender(() => {
                this.shadowGenerators.forEach((shadowGenerator) => {
                    const map = shadowGenerator.getShadowMap();
                    map.refreshRate = RenderTargetTexture.REFRESHRATE_RENDER_ONCE;
                });
            });
        }
    }

    private optimizedShadows = true

    public optimizeShadows(): void {
        this.optimizedShadows = true;
    }

    public unOptimizeShadows(): void {
        this.optimizedShadows = false;
    }
}
